import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useEditProjectDialogStyles = makeStyles({
  attachmentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
    minHeight: "450px",
  },
  attachmentListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    maxHeight: "320px",
    overflowY: "auto",
  },
  pendingCard: {
    padding: designTokens.spacing[3],
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.sm,
    backgroundColor: designTokens.neutral.white,
    overflow: "hidden",
    flexShrink: 0,
  },
  fileInfoContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    minWidth: 0,
    flex: 1,
  },
  fileInfoInnerContainer: {
    minWidth: 0,
    flex: 1,
  },
  fileIconSmall: {
    fontSize: designTokens.fontSize.base,
    flexShrink: 0,
  },
  fileName: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileSize: {
    opacity: 0.6,
    flexShrink: 0,
  },
  actionsContainer: {
    display: "flex",
    gap: designTokens.spacing[1],
    flexShrink: 0,
    alignItems: "center",
  },
  fieldsRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1.5fr",
    gap: designTokens.spacing[3],
    alignItems: "flex-start",
  },
  fieldSelect: {
    width: "100%",
    boxSizing: "border-box",
  },
  fieldSelectWithMin: {
    width: "100%",
    boxSizing: "border-box",
    minWidth: 0,
  },
  fieldsContentColumn: {
    minWidth: 0,
  },
  fieldOption: {
    maxWidth: "160px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});
